import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  AccountSummaryWrapper,
  FormFlex,
  FormFlexDiv,
  ImageUploadContainer,
  ImageWrapper,
  TabContentWrapper,
} from "../../pages/Dashboard/styles/dashboard.style";
import colors from "../../assets/colors.json";
import avatar from "../../assets/Images/avatar.jpg";
import ImageUploader from "react-images-upload";
import { InputWrapper, AuthButton } from "../../pages/auth/Login.style";
import Select from "../select/select";
import { useMediaQuery } from "react-responsive";
import Upload from "../../assets/icons/upload";
import FormLoader from "../FormLoader";
import { createNOK, deleteNOK, getNOK } from "../../services/user";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { convertToBase64 } from "../../utils";
import TableLoader from "../TableLoader";
const containerStyle = {
  background: "transparent",
  boxShadow: "none",
  padding: "0px",
  justifyContent: "flex-start",
  margin: "0",
};

const style = {
  background: "white",
  color: colors.primary,
};

const NOK = ({ status }) => {
  const imageInputRef = useRef(null);
  const [loadingNOK, setLoadingNOK] = useState(false);
  const [loadingUploading, setLoadingUploading] = useState(false);
  const [edit, setEdit] = useState(false);
  const [data, setData] = useState(null);
  const { user, admToken, } = useSelector((state) => state.auth);
  const [selectedPic, setSelectedPic] = useState(null);
  const [loadingDeleting, setLoadingDeleting] = useState(null);
  const [imagePreviewPic, setImagePreviewPic] = useState(null);
  const [form, setForm] = useState({
    firstName: "",
    surName: "",
    title: "",
    nextKinType: " ",
    profileImageurl: "",
    email: "",
    phoneNumber: "",
    address: "",
    relationShip: "",
    id: 0
  });

  const optionsArr = [
    {
      id: 1,
      name: "Mr",
    },
    {
      id: 2,
      name: "Mrs",
    },
    {
      id: 3,
      name: "Miss",
    },
    {
      id: 3,
      name: "Dr",
    },
    {
      id: 3,
      name: "Prof",
    },
  ];

  const nokTypes = [
    {
      id: 1,
      name: "Spouse",
    },
    {
      id: 2,
      name: "Child",
    },
    {
      id: 3,
      name: "Relation",
    },
  ];
  const isNumber = (evt) => {
    // console.log(evt);
    evt = evt ? evt : window.event;
    var charCode = evt.which ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
      evt.preventDefault();
    } else {
      return true;
    }
  };

  const getNok = useCallback(async () => {
    try {
      setLoadingNOK(true)
      const res = await getNOK(admToken, user?.staffId);
      console.log(res);
      if (res.status && res.statusCode === 2) {
        setData(res.data);
      } else {
        setData(null);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingNOK(false)
    }
  }, [admToken, user?.staffId]);

  useEffect(() => {
    getNok();
  }, [user?.staffId])

  useEffect(() => {
    if (data) {
      setForm({
        firstName: data.firstName || "",
        surName: data.surName || "",
        title: data.title || "",
        nextKinType: data.nextKinType || "",
        profileImageurl: data.profileImageurl || "",
        email: data.email || "",
        phoneNumber: data.phoneNumber || "",
        address: data.address || "",
        relationShip: data.relationShip || "",
        id: data.id || 0
      });
    }
  }, [data])

  const handleUpdate = async () => {
    const payload = {
      firstName: form.firstName,
      surName: form.surName,
      title: form.title,
      nextKinType: form.nextKinType,
      profileImageurl: selectedPic || form.profileImageurl,
      email: form.email,
      phoneNumber: form.phoneNumber,
      address: form.address,
      relationShip: form.relationShip,
      id: form.id || 0
    }
    try {
      setLoadingUploading(true)
      const res = await createNOK(admToken, payload, user?.staffId);
      if (res.status && res.statusCode === 2) {
        toast.success(res.message);
        setForm({
          firstName: "",
          surName: "",
          title: "",
          nextKinType: " ",
          profileImageurl: "",
          email: "",
          phoneNumber: "",
          address: "",
          relationShip: "",
          id: 0
        });
        setEdit(false)
        getNok();
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingUploading(false)
    }
  };

  const handleEdit = (item) => {
    setForm({
      firstName: item.firstName,
      surName: item.surName,
      title: item.title,
      nextKinType: item.nextKinType,
      profileImageurl: item.profileImageurl || "",
      email: item.email,
      phoneNumber: item.phoneNumber,
      address: item.address,
      relationShip: item.relationShip,
      id: item.id,
    });
    setEdit(true)
  };

  const handleDelete = async (id) => {
    try {
      setLoadingDeleting(id);
      const res = await deleteNOK(admToken, id);
      if (res.status && res.statusCode === 2) {
        toast.success(res.message);
        getNok();
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingDeleting(null);
    }
  };

  const handleImageClick = () => {
    imageInputRef.current?.click();
  };

  const handleFileChangeImage = async (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    if (imagePreviewPic) URL.revokeObjectURL(imagePreviewPic);

    const previewUrl = URL.createObjectURL(file);
    setImagePreviewPic(previewUrl);

    const base64String = await convertToBase64(file);
    setSelectedPic(base64String);
  };

  return (
    <TabContentWrapper>
      <>
        <FormFlex reverse={true}>
          <FormFlexDiv>
            <InputWrapper>
              <label htmlFor="Degree">Title</label>
              <Select
                title="Title"
                index="name"
                selected={form.title}
                options={optionsArr}
                setSelected={(val) => {
                  setForm({ ...form, title: val.name });
                }}
                disabled={!(status === 0 || status === 4) || loadingNOK}
              />
            </InputWrapper>
            <InputWrapper>
              <label htmlFor="first_name">First Name</label>
              <input
                type="text"
                placeholder="First Name"
                value={form.firstName}
                onChange={(e) =>
                  setForm({ ...form, firstName: e.target.value })
                }
                disabled={!(status === 0 || status === 4) || loadingNOK}
              />
            </InputWrapper>
            <InputWrapper>
              <label htmlFor="last_name">Last Name</label>
              <input
                type="text"
                placeholder="Last Name"
                value={form.surName}
                onChange={(e) => setForm({ ...form, surName: e.target.value })}
                disabled={!(status === 0 || status === 4) || loadingNOK}
              />
            </InputWrapper>
          </FormFlexDiv>
          <FormFlexDiv>
            <div className="flex item-center justify-center">
              <div className="h-[230px] w-[230px] rounded-md overflow-hidden">
                <div
                  className="relative h-full cursor-pointer"
                  onClick={handleImageClick}
                >
                  <div className="overflow-hidden">
                    <input
                      type="file"
                      ref={imageInputRef}
                      onChange={handleFileChangeImage}
                      accept="image/jpeg"
                      hidden
                    />

                    {imagePreviewPic || data?.profileImageurl ? (
                      <img
                        src={
                          imagePreviewPic ??
                          data?.profileImageurl ??
                          'https://placehold.co/200x200?text=No+Images'
                        }
                        alt="profile"
                        className="w-full h-full object-cover"
                      />
                    ) : (
                      <div className="flex flex-col space-y-6 justify-center py-10 items-center p-5 mb-2">
                        <img
                          src={avatar}
                          alt="profile"
                          className="w-full h-full object-cover"
                        />
                      </div>
                    )}
                  </div>
                </div>

                <div
                  className="w-full h-[50px] bg-white flex items-center justify-center cursor-pointer border border-gray-200"
                  onClick={handleImageClick}
                >
                  <Upload />
                </div>
              </div>
            </div>
          </FormFlexDiv>
        </FormFlex>
        <FormFlex>
          <FormFlexDiv>
            <InputWrapper>
              <label htmlFor="Degree">Type</label>
              <Select
                title="Type"
                index="name"
                selected={form.nextKinType}
                options={nokTypes}
                setSelected={(val) => {
                  setForm({ ...form, nextKinType: val.name });
                }}
                disabled={!(status === 0 || status === 4) || loadingNOK}
              />
            </InputWrapper>
          </FormFlexDiv>
          <FormFlexDiv>
            <InputWrapper>
              <label htmlFor="Email">NOK Email</label>
              <input
                type="text"
                placeholder="Email"
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
                disabled={!(status === 0 || status === 4) || loadingNOK}
              />
            </InputWrapper>
          </FormFlexDiv>
        </FormFlex>
        <FormFlex reverse={true}>
          <FormFlexDiv>
            <InputWrapper>
              <label htmlFor="Address">Address</label>
              <textarea
                name=""
                id=""
                cols="30"
                rows="4"
                value={form.address}
                onChange={(e) => setForm({ ...form, address: e.target.value })}
                disabled={!(status === 0 || status === 4) || loadingNOK}
              ></textarea>
            </InputWrapper>
          </FormFlexDiv>
          <FormFlexDiv>
            <InputWrapper>
              <label htmlFor="phone-number"> Phone Number</label>
              <input
                type="text"
                onKeyDown={(e) => isNumber(e)}
                placeholder="Employer's Phone Number"
                value={form.phoneNumber}
                onChange={(e) =>
                  setForm({ ...form, phoneNumber: e.target.value })
                }
                disabled={!(status === 0 || status === 4) || loadingNOK}
              />
            </InputWrapper>
            <InputWrapper>
              <label htmlFor="Relationship">Relationship</label>
              <input
                type="text"
                placeholder="Relationship"
                value={form.relationShip}
                onChange={(e) =>
                  setForm({ ...form, relationShip: e.target.value })
                }
                disabled={!(status === 0 || status === 4) || loadingNOK}
              />
            </InputWrapper>
          </FormFlexDiv>
        </FormFlex>
        {status === 4 || status === 0 && (
          <div className="flex items-center justify-end my-7">
            <button
              disabled={loadingUploading}
              onClick={handleUpdate}
              className="px-8 py-2.5 rounded-lg text-white bg-primary disabled:cursor-not-allowed disabled:bg-gray-300"
            >
              {loadingUploading ? edit ? "updating" : "Adding..." : edit ? "Update" : "Add"}
            </button>
          </div>
        )}
      </>
      <AccountSummaryWrapper
        style={{
          border: `1px solid ${colors.primary}`,
          paddingTop: "0px",
          borderRadius: "10px",
          marginTop: "10px",
        }}
      >
        <table>
          <tr className="table-head" style={{ color: "black" }}>
            <th>Name</th>
            <th>Next of Kin Type</th>
            <th>Relationship</th>
            <th>Phone No</th>
            <th></th>
          </tr>
          {loadingNOK ?
            <tr colSpan={5}>
              <div className="flex items-center justify-center"><TableLoader /></div>
            </tr>
            : data?.length > 0 ? (
              data?.map((item, index) => (
                <tr key={index}>
                  <td>{`${item.title} ${item.firstName} ${item.surName}`}</td>
                  <td>{item.nextKinType}</td>
                  <td>{item.relationShip}</td>
                  <td>{item.phoneNumber}</td>
                  <td>
                    <div
                      style={{
                        width: "100%",
                        display: "inline-flex",
                        justifyContent: "space-evenly",
                      }}
                    >
                      <button
                        style={{
                          color: "black",
                          fontWeight: "bold",
                          padding: "0.3rem 0.6rem",
                          backgroundColor: "transparent",
                          borderColor: colors.primary,
                          borderWidth: "1px",
                          borderRadius: "5px",
                        }}
                        onClick={() => handleDelete(item.id)}
                        disabled={!(status === 0 || status === 4) || loadingDeleting === item.id}
                      >
                        Delete
                      </button>
                      <button
                        style={{
                          color: "black",
                          fontWeight: "bold",
                          padding: "0.3rem 0.6rem",
                          backgroundColor: "transparent",
                          borderColor: colors.primary,
                          borderWidth: "1px",
                          borderRadius: "5px",
                        }}
                        onClick={() => { handleEdit(item) }}
                        disabled={!(status === 0 || status === 4) || loadingNOK || loadingUploading}
                      >
                        Edit
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={5} style={{ textAlign: "center" }}>
                  <p className="text-center p-4">
                    No Next Of Kin For Staff.
                  </p>
                </td>
              </tr>
            )}
        </table>
      </AccountSummaryWrapper>
    </TabContentWrapper>
  );
};

export default NOK;
